import Vue from 'vue'

const admin_roles = ['CA']

export const is_user_admin = () => {
    const current_user = JSON.parse(localStorage.getItem('user'))
    if(
        localStorage.getItem('jwt') !== null
        && current_user
        && admin_roles.includes(current_user.roleCode)
    ){ 
        return true 
    } else {
        return false
    }
}
export const get_user_timezone = () => {
    const current_user = JSON.parse(localStorage.getItem('user'))
    //console.log('get_user_timezon: user tz = ' + JSON.stringify(current_user.timeZone))
    return current_user.timeZone
}

export const convert_timezone = (tz) => {
    //const current_user = JSON.parse(localStorage.getItem('user'))
    //console.log('get_user_timezon: user tz = ' + JSON.stringify(current_user.timeZone))
    if (tz.includes('America') || tz.includes('Pacific')) {
        return tz
    } else if (tz == 'Etc/GMT+8') {
        return 'America/Los_Angeles'
    } else if (tz == 'Etc/GMT+7') {
        return 'America/Denver'
    } else if (tz == 'Etc/GMT+6') {
        return 'America/Chicago'
    } else if (tz == 'Etc/GMT+5') {
        return 'America/New_York'
    } else if (tz == 'Etc/GMT+9') {
        return 'America/Anchorage'
    } else if (tz == 'Etc/GMT+10') {
        return 'Pacific/Honolulu'
    } else {
        return 'America/Los_Angeles'
    }
}

export const format_date_value_date = (date,user_tz) => {
    if (date != null) {
        let formatDate = Vue.filter('formatDateTimeTZ')(date,user_tz)
        return formatDate
    }
}

export const get_formatted_date = (value) => {
    const current_user = JSON.parse(localStorage.getItem('user'))
    let tz = current_user.timeZone

    return format_date_value_date(value,tz)
}